// Firebase configuration
// NOTE: These values are exposed in the browser and are intentionally public.
// They do NOT include secret keys; authentication is protected by Firestore rules.
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyA1yxZv3FgPS2921Pgws1Mw2wddA8gVmpE",
  authDomain: "kidguard-6323b.firebaseapp.com",
  projectId: "kidguard-6323b",
  storageBucket: "kidguard-6323b.firebasestorage.app",
  messagingSenderId: "725608801729",
  appId: "1:725608801729:web:94ce5e3dfffe1fc34ebb40",
};

// App constants
export const SIDEBAR_WIDTH = 220;
export const HEADER_HEIGHT = 60;
export const BORDER_RADIUS = 12;

// API endpoints
export const API_BASE = import.meta.env.VITE_API_BASE || "http://localhost:5001";

// Feature flags
export const FEATURES = {
  screenShare: true,
  networkPolicy: true,
  analytics: true,
  advancedSettings: false,
};
